module.exports = __webpack_public_path__ + "images/deepLinkingIcon-09572ea11b00c77a1c0dffdac1b00f7a.svg";